// @ts-strict-ignore
import clsx from 'clsx'

import { formatPrice } from '@/shared/lib/utils/price/format-price'
import { TPrice } from '@/shared/types/deprecated-types'

import cl from './product-price.module.scss'

export interface ProductPriceProps {
	oldPrice?: TPrice
	price?: TPrice
	oldPricePosition?: `left` | `right`
	oldPriceMargin?: boolean
	flat?: boolean
	centered?: boolean
	revert?: boolean
	min?: boolean
	column?: boolean
	is_archive?: boolean
}

export const ProductPrice = ({
	oldPrice,
	price,
	oldPricePosition = `left`,
	oldPriceMargin = true,
	flat = false,
	centered = false,
	revert = false,
	min = false,
	column = false,
	is_archive
}: ProductPriceProps): JSX.Element => {
	const wrapperClassName = clsx(cl.productPrice, {
		[cl.productPriceFlat]: flat,

		[cl.productPriceColumn]: column,
		[cl.productPriceCentered]: centered
	})

	const oldPriceClasses = clsx(cl.productPriceOldPrice, {
		[cl.productPriceOldPriceMargin]: oldPriceMargin,
		[cl.productPriceOldPriceColumn]: column,
		[cl.productPriceOldPriceFlat]: flat,
		[cl.productPriceOldPriceCentered]: centered,
		[cl.productPriceOldPriceMin]: min
	})

	const mainPriceClasses = clsx(cl.productPriceMain, {
		[cl.productPriceMainMin]: min
	})

	const showOldPrice = !is_archive && oldPrice && price && oldPrice.VALUE !== price.VALUE
	const showPrice = !is_archive && !!price?.VALUE

	if (revert) {
		return (
			<div className={wrapperClassName}>
				{showPrice && <span className={mainPriceClasses}>{formatPrice(price.VALUE)}</span>}
				{showOldPrice && (
					<span className={oldPriceClasses} style={{ textAlign: oldPricePosition }}>
						{formatPrice(oldPrice.VALUE)}
					</span>
				)}
			</div>
		)
	}

	return (
		<div className={wrapperClassName}>
			{showOldPrice && (
				<span className={oldPriceClasses} style={{ textAlign: oldPricePosition }}>
					{formatPrice(oldPrice.VALUE)}
				</span>
			)}

			{showPrice && <span className={mainPriceClasses}>{formatPrice(price.VALUE)}</span>}
		</div>
	)
}
